import React, { useEffect, useRef, useState } from 'react';
import ParityDialog from './ParityDialog';
export default function useParityConfirm() {
  const [message, setMessage] = useState('');
  const pending = useRef(null);
  const finish = answer => { const resolve = pending.current; pending.current = null; setMessage(''); resolve?.(answer); };
  useEffect(() => () => { pending.current?.(false); }, []);
  const confirm = text => {
    if (pending.current) return Promise.resolve(false);
    setMessage(text);
    return new Promise(resolve => { pending.current = resolve; });
  };
  return [confirm, message ? <ParityDialog title="تایید عملیات" submitLabel="تایید" onClose={() => finish(false)} onSubmit={() => finish(true)}><p style={{whiteSpace:'pre-line'}}>{message}</p></ParityDialog> : null];
}
